import { render, staticRenderFns } from "./LivePauseConfirm.vue?vue&type=template&id=e052f4c6&scoped=true"
import script from "./LivePauseConfirm.vue?vue&type=script&lang=js"
export * from "./LivePauseConfirm.vue?vue&type=script&lang=js"
import style0 from "./LivePauseConfirm.vue?vue&type=style&index=0&id=e052f4c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e052f4c6",
  null
  
)

export default component.exports